import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box, Chip } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

function TemplateCard({ template, selected, onClick }) {
    return (
        <Card
            onClick={onClick}
            sx={{
                cursor: 'pointer',
                border: selected ? 2 : 1,
                borderColor: selected ? 'primary.main' : 'divider',
                borderRadius: 2,
                transition: 'all 0.2s',
                '&:hover': {
                    borderColor: 'primary.main',
                    boxShadow: 4,
                    transform: 'translateY(-4px)',
                },
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {selected && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 2,
                        bgcolor: 'primary.main',
                        borderRadius: '50%',
                        p: 0.5,
                    }}
                >
                    <CheckCircle sx={{ color: 'white', fontSize: 24 }} />
                </Box>
            )}
            <CardMedia
                component="img"
                height="200"
                image={template.screenshot_path || '/assets/imgs/placeholder.png'}
                alt={template.name}
                sx={{
                    objectFit: 'cover',
                    bgcolor: 'grey.100',
                }}
            />
            <CardContent>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                    {template.name}
                </Typography>
                {template.description && (
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        {template.description}
                    </Typography>
                )}
                <Chip
                    label={template.theme_name}
                    size="small"
                    color="primary"
                    variant="outlined"
                />
            </CardContent>
        </Card>
    );
}

export default TemplateCard;

